export default "__VITE_ASSET__3930fa32__"